import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstagram = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 2.75,
		y: 2.75,
		width: 18.5,
		height: 18.5,
		rx: 6.28499,
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("rect", {
		x: 8.75,
		y: 8.75,
		width: 6.5,
		height: 6.5,
		rx: 3.25,
		stroke: "currentColor",
		strokeWidth: 1.5
	})]
});
export default SvgInstagram;
